export const petSexLabels = {
  male: 'Чоловіча',
  female: 'Жіноча',
};

export const petSexIdMap = {
  1: 'male',
  2: 'female',
};